'use client';

import { use } from 'react';

import { type EnsureChargesEnabled, StripeConnectGateContext } from './context';

/**
 * Returns the imperative gate: `ensureChargesEnabled(actionLabel, next)`. Call
 * it from a paid-feature action handler — `next()` runs only if the creator can
 * accept charges; otherwise the gate prompts them to complete Stripe onboarding.
 * Requires a `<StripeConnectGateProvider>` ancestor.
 */
export function useEnsureChargesEnabled(): EnsureChargesEnabled {
  const ctx = use(StripeConnectGateContext);
  if (!ctx) {
    throw new Error(
      'useEnsureChargesEnabled must be used inside <StripeConnectGateProvider>',
    );
  }
  return ctx.ensureChargesEnabled;
}
